import axios from "axios";

// Create an Axios instance
const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("QC_accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status, data, config } = error.response || {};
    const isLoginPage = config?.url?.includes("/login");

    switch (status) {
      case 400:
        // Bad Request - client side error
        console.error(
          "Bad Request:",
          data?.message || "Invalid request parameters"
        );
        // You might want to show validation errors to the user
        break;

      case 401:
        // Unauthorized - token expired or invalid
        console.warn("Unauthorized - redirecting to login");
        localStorage.removeItem("QC_accessToken");
        localStorage.removeItem("QC_refreshToken");

        // Only redirect if not already on login page and not a login request
        if (!isLoginPage && !window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
        break;

      case 403:
        // Forbidden - user doesn't have permission
        console.error(
          "Forbidden: You don't have permission to access this resource"
        );
        // Could redirect to a "not authorized" page or show a modal
        break;

      case 404:
        // Not Found
        console.error("Resource not found:", error.config.url);
        break;

      case 408:
        // Request Timeout
        console.error("Request timeout - please try again");
        break;

      case 429:
        // Too Many Requests - rate limiting
        console.error("Too many requests - please slow down");
        // You might implement a retry mechanism with exponential backoff
        break;

      case 500:
        // Internal Server Error
        console.error("Server error - please try again later");
        break;

      case 502:
        // Bad Gateway
        console.error("Bad gateway - service temporarily unavailable");
        break;

      case 503:
        // Service Unavailable
        console.error("Service unavailable - please try again later");
        break;

      case 504:
        // Gateway Timeout
        console.error(
          "Gateway timeout - service is taking too long to respond"
        );
        break;

      default:
        // Network error or other unexpected errors
        if (error.code === "NETWORK_ERROR" || error.code === "ECONNABORTED") {
          console.error("Network error - please check your connection");
        } else {
          console.error("Unexpected error:", error.message);
        }
        break;
    }

    return Promise.reject(error);
  }
);

export default api;
